import React, {Component} from 'react';
import {Redirect} from "react-router";

class Logout extends Component {
    constructor(props) {
        super(props);

        axios.get('/api/logout')
            .then(
                data => {
                    this.props.mark_as_logged_out();
                },
                error => {

                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });

    }

    render(props) {
        if (! this.props.is_logged_in) {
            return (<Redirect push={true} to="/auth/login"/>)
        }

        return (<div>Logging out</div>);
    }
}

export default Logout;
